<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>Webmail Access</template>
    <template v-slot:body>
      <v-progress-circular v-if="loading" indeterminate size="64" color="primary" />
      <v-form v-else :action="authUrl" method="post" target="_blank">
        <input type="hidden" name="session" :value="session" />
        <gg-btn type="submit" color="primary" tile>Continue to Webmail</gg-btn>
      </v-form>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'WebmailAccessModal',
  mixins: [modalMixin],
  props: {
    domain: {
      required: true,
      type: String,
    },
    login: {
      required: true,
      type: String,
    },
  },
  data () {
    return {
      loading: true,
      authUrl: '',
      session: '',
    }
  },
  methods: {
    ...mapActions(['cpanel_uapi', 'reportError', 'reportSuccess']),
    async prepareWebmail () {
      this.loading = true
      let response
      const data = {
        uapi_module: 'Session',
        uapi_function: 'create_webmail_session_for_mail_user',
        login: this.login.split('@')[0],
        domain: this.domain,
        _username: this.$route.query.user,
      }
      // get session data
      try {
        response = await this.cpanel_uapi(data)
      } catch (e) {
        this.loading = false
        this.reportError(e)
        return
      }
      const domainAuth = response.payload.data.hostname || this.domain
      const token = response.payload.data.token
      const authUrl = `https://${domainAuth}:2096${token}/login`
      this.authUrl = authUrl
      this.session = response.payload.data.session
      this.loading = false
    },
  },
  watch: {
    dialog (newVal) {
      if (newVal) {
        this.prepareWebmail()
      } else {
        this.loading = true
      }
    }
  }
}
</script>
